import UserTransformer from 'src/transformers/UserTransformer';
import { userRoles } from 'src/services/constants';

export function setUsers(state, users) {
  state.users = users;
  Object.keys(state.users).forEach((key) => {
    state.users[key] = UserTransformer.transform(state.users[key]);
  });
}

export function loadingUsers(state) {
  state.usersLoading = true;
}

export function usersLoaded(state) {
  state.usersLoading = false;
  state.usersReadyResolve();
}

export function clearUserBeingEdited(state) {
  state.userBeingEdited = {
    firstName: '',
    lastName: '',
    accountRole: userRoles.VIEWER,
    email: '',
    smsPhoneNumber: '',
    appIds: [],
    groups: [],
    groupKeys: [],
    tags: [],
    tagKeys: [],
    emailNotification: true,
    pushNotification: true,
    tripEvents: 'none',
    locationEvents: false,
    preferredLocale: null,
    vehicleLocationEvents: 'all',
    lowFuelEvents: 'all',
    vehicleMaintenanceEvents: 'all',
    vehicleHealthEvents: true,
    vehicleScheduleEvents: 'all',
    hardBrakingEvents: true,
    crashEvents: true,
    overSpeedEvents: true,
    deviceEvents: true,
    marketingOptOut: false,
    bulletingFrequency: '',
  };
}

export function setUserBeingEdited(state, user) {
  Object.assign(state.userBeingEdited, user);
}

export function setExtendedUserDetails(state, user) {
  state.extendedUserDetails = user;
}

export function setAlertSuggestions(state, alertSuggestions) {
  state.alertSuggestions = alertSuggestions;
}

export function setUsersError(state, error) {
  if (!error) {
    state.usersError = {};
    state.usersErrorMessage = null;
    return;
  }

  if (typeof error === 'object') {
    state.usersError = error;
    state.usersErrorMessage = null;
  } else {
    state.usersError = {};
    state.usersErrorMessage = error;
  }
}

export function setChangePasswordError(state, error) {
  state.changePasswordError = error || false;
}

export function setSavingUser(state, savingUser) {
  state.savingUser = savingUser;
}

export function setInvite(state, invite) {
  state.invite = invite;
}

export function clearInvite(state) {
  state.invite = null;
}
